<template>
  <Transition name="showPopup">
  <div v-show="visible" class="process-search-popup" :class={open:visible}
    :style="{ left: `${positionX}px`, top: `${positionY}px` }"
    @mousedown="startDragging"
    @mousemove="dragElement"
    @mouseup="stopDragging"
    @mouseleave="stopDragging"  
  >
    <div class="process-search-wrap">
      <h2>{{ type == 'process' ? '공정도 검색' : '프로토콜 검색'}}</h2>
      <ul class="protocol_label_list" v-if="type==='onlyProtocol' && !overWriteProtocolMode">
          <span>선택된 프로토콜 : </span>
          <li class="label_01" 
              v-for="(targetProtocolTag, index) in targetProtocolTagList" 
              :key="index"
              :class="targetProtocolTag['class']"
          >
              <span>{{targetProtocolTag['text']}}</span>
          </li>
      </ul>
      <button class="search-close" @click="hide">닫기</button>
      <div class="search-option" @click="preventDrag" @mousedown="preventDrag">
        <ProcessFieldSelector  :options="type" @change="(value)=>selectSearchFiled=value.value" />
        <ProtocolFieldSelector v-if="type=='protocol'" @dataChange="(value)=>selectSearchType=value.value" />
        <ProcessTargetSelector :options="type" @change="(value)=>selectSearchTarget=value.value"/>
<!--        <SortSelector v-if="type=='unitProtocol'" @change="(value)=>sortSet(value.value)"/>-->
        <span>검색어</span>
        <div class="search-input">
          <input type="text" @keydown="inputEnter" @input="setSearchInputData" :value="searchInputData" />
          <!--          <button @click="pageNo=1; totalPage=0; search();">검색</button>-->
        </div>
        <btn-link class="search_btn" :style="{minWidth: '80px'}" @click="pageNo=1; totalPage=0; search();">검색</btn-link>

        <div style="display: inline-flex" v-show="type != 'unitProtocol'">
          <span style="line-height: 30px;">재료</span>
          <label class="myProcess">
            <input type="checkbox" class="searchMaterial" v-model="similarMaterial" @change="clear">
          </label>
          <div class="search-input-tag" :style="{'background-color' : !similarMaterial? `whitesmoke`:``}">
            <input type="text" @keydown="inputEnter" :style="{'background-color' : !similarMaterial? `whitesmoke`:``}"
                   @input="setSearchMaterial" :value="searchMaterial" :readonly="!similarMaterial"/>
          </div>
        </div>
        <div style="display: inline-flex" v-show="type != 'unitProtocol'">
          <span style="line-height: 30px;">목적</span>
          <label class="myProcess">
            <input type="checkbox" class="searchPurpose" v-model="similarPurpose" @change="clear">
          </label>
          <div class="search-input-tag" :style="{'background-color' : !similarPurpose? `whitesmoke`:``}">
            <input type="text" @keydown="inputEnter" :style="{'background-color' : !similarPurpose? `whitesmoke`:``}"
                   @input="setSearchPurpose" :value="searchPurpose" :readonly="!similarPurpose"/>
          </div>
        </div>
        <div style="display: inline-flex">
          <span style="line-height: 30px;">장비</span>
          <label class="myProcess">
            <input type="checkbox" class="searchEquipment" v-model="similarEquipment" @change="clear">
          </label>
          <div class="search-input-tag" :style="{'background-color' : !similarEquipment? `whitesmoke`:``}">
            <input type="text" @keydown="inputEnter" :style="{'background-color' : !similarEquipment? `whitesmoke`:``}"
                   @input="setSearchEquipment" :value="searchEquipment" :readonly="!similarEquipment"/>
          </div>
        </div>
        <div style="display: inline-flex" class="tooltip_box">
          <span class="tooltip_ico"></span>
          <div class="tooltip_txt">
            <p>
              재료:[금], 목적:[구조측정], 장비:[xps]인 프로토콜에서 검색 시 <br>
              1. 장비에만 체크 후 공백 : <br>
              재료:[금], 목적: [구조측정]인 프로토콜 검색<br>
              (장비는 전체검색)<br>
              2. 장비에만 체크 후 'tem'입력 : <br>
              재료가 [금], 목적: [구조측정]이면서 장비 사전에 'tem'이 포함되어있는 프로토콜 검색
            </p>
          </div>
        </div>
        <div style="display: block; width: 100%">
          <h4 style="font-size: 15px">
            <p>
              ※체크박스 체크 후 공백을 입력 => 전체 검색.
            </p>
            <p>
              ※체크박스 체크 후 검색어 입력 => 검색 텍스트 기반 사전 검색.
            </p>
            <p>
              ※체크박스 해제 시 => 체크한 검색조건(재료 또는 목적 또는 장비)과 동일한 사전 검색
            </p>
          </h4>
        </div>
<!--        <label class="myProcess">
          <input type="checkbox" v-model="checkMyProcess" @change="search()">
          내가 작성한 문서
        </label>-->
        <!-- <button class="processRemove" :disabled="this.myProcessAllCheck === 0 ? true : false" @click="processDeleteAlert=true">선택삭제</button> -->
      </div>
      <div class="search-table" @click="preventDrag" @mousedown="preventDrag">
        <font v-if="type == 'unitProtocol'" color="red">"선택 유닛 붙이기" 버튼 클릭시 선택한 유닛프로토콜이 현재 작성중인 프로토콜에 적용됩니다.</font>
        <table class="search-result">
          <thead>
            <tr>
              <th>
                  <span v-if="type==='onlyProtocol' && !overWriteProtocolMode" >
                      정보확인
                  </span>
              </th>
              <th>생성/수정일</th>
              <th>{{ type == 'process' ? '분야' : '구분'}}</th>
              <th>{{ type == 'process' ? '공정도명' : '프로토콜명'}}</th>
              <th>작성자</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in processList" @click="selectProcess(index, $event)" :data-list-index="index" 
              :class = "{on: (index === selectedProcessIndex)}" 
              @dblclick="targetEditor" 
            >
              <td v-if="type==='onlyProtocol' && !overWriteProtocolMode"
                  @mouseover="setShowProtocolTag(index)" 
                  @mouseleave="setShowProtocolTag(null)">
                <span>
                  <span>
                    <div class="tooltip_box"> <span class="tooltip_ico"></span></div>
                  </span>
                </span>
                <div v-show="index === connectProtocolTagShowIndex" 
                     :style="index === connectProtocolTagShowIndex ? 'display : block' : 'display : none'" 
                     style="position: absolute;">
                  <ul class="protocol_label_list">
                    <li class="label_01 material" v-if="item['material'] && item['material']?.trim() != 0">
                        <span v-html="item['material']"></span>
                    </li> 
                    <li class="label_02 measurement" v-if="item['measurement'] && item['measurement']?.trim() != 0">
                        <span v-html="item['measurement']"></span>
                    </li> 
                    <li class="label_04 analysis" v-if="item['analysis'] && item['analysis']?.trim() != 0">
                        <span v-html="item['analysis']"></span>
                    </li> 
                    <li class="label_03 equipment" v-if="item['equipment'] && item['equipment']?.trim() != 0">
                        <span v-html="item['equipment']"></span>
                    </li> 
                  </ul>
                </div>
              </td>
              <td v-else></td>
              <td>
                <span>{{(item.createdDate || item.createDate) | timeFilter}}</span>
                <span>{{(item.updatedDate || '') | timeFilter}}</span>
              </td>

              <td v-html="type == 'process' ?  item.fieldName : `${item.protocolType} (${item.equipment})`"></td>
              <td v-html="type == 'process' ?  item.processName : item.protocolName"></td>
              <td>{{item.userName ? item.userName : item.user.userName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination ref="resultsCount" :pageCnt="pageNo" :pageTotalCnt="totalPage" :size="9" @click="selectPage" @setMethod="getChildMethods"></Pagination>
      <div class="button-wrap" @click="preventDrag" @mousedown="preventDrag">
        <btn-link v-if="type==='process'" :style="{minWidth: '80px'}" @click="processPreview">선택 미리보기</btn-link>
        <!-- <btn-link v-if="type==='process' || type==='protocol'" color="blue" :style="{minWidth: '80px'}" @click="targetEditor">선택 편집하기</btn-link>-->
        <btn-link v-if="type==='onlyProtocol' || type==='unitProtocol'" :style="{minWidth: '80px'}" @click="protocolPreview">선택 미리보기</btn-link>
        <!--<btn-link v-if="type==='onlyProtocol' && overWriteProtocolMode" color="blue" :style="{minWidth: '80px'}" @click="overwriteProtocol">선택 프로토콜 덮어쓰기</btn-link>-->
        <btn-link v-if="type==='onlyProtocol' && !overWriteProtocolMode" color="blue" :style="{minWidth: '80px'}" @click="setProtocol">선택 프로토콜 연결하기</btn-link>
        <btn-link v-if="type==='unitProtocol'" color="blue" :style="{minWidth: '80px'}" @click="setUnitProtocol">선택 유닛 붙이기</btn-link>
      </div>
    </div>
    <div v-show="processDeleteAlert" class="alertPopup">
      <div class="layout">
        <h2 class="title">공정도를 삭제하시겠습니까?</h2>
        <p class="content">해당 공정도에서 생성된 프로토콜도<br> 함께 삭제됩니다.</p>
        <div class="buttons-wrap">
          <btn-link :style="{minWidth: '60px'}" @click="processDeleteAlert=false" >취소</btn-link>
          <btn-link color="blue" :style="{minWidth: '80px'}" @click="processDelete" >삭제하기</btn-link>
        </div>
      </div>
    </div>
    <customConfirmLayerPopup
            :active.sync = "customConfirmLayerPopupFlag"
            @utilizeProtocol = "utilizeProtocol"
            @openModifyTagLayerPopup = "openModifyTagLayerPopup"
    ></customConfirmLayerPopup>
    <modifyTagLayerPopup
            :active.sync = "modifyTagLayerPopupActive"
            @setTargetProtocolTag = "setTargetProtocolTag"
    ></modifyTagLayerPopup>
    <Loading :visible="loading"/>
  </div>
  </Transition>
  </template>
  
  <script>
  import CommNew from "@processEditor/CommNew";
  import { createNamespacedHelpers } from 'vuex';
  import {checkProtocolLink} from "@/mixins/makeLinkInfo";
  import ProcessFieldSelector from '../common/selects/FieldSelector.vue'
  import ProcessTargetSelector from '../common/selects/TargetSelector.vue'
  import SortSelector from '../common/selects/SortSelector.vue'
  import Pagination from './Pagination.vue'
  import BtnLink from '../btns/BtnLink.vue'
  import Loading from '../common/loading.vue'
  import {v4} from "uuid";
  import customConfirmLayerPopup from "@modal/customConfirmLayerPopup"
  import modifyTagLayerPopup from '@modal/modifyTagLayerPopup'

  const ProcessSelector = createNamespacedHelpers('ProcessSearch');
  const ProcessEditor = createNamespacedHelpers('ProcessEditor');
  const Dictionary = createNamespacedHelpers('Dictionary');

  export default {
  name: 'process-search',
  mixins : [ CommNew ] ,
  props: {
    type: String,
    searchLinkData : Object,
    overWriteProtocolMode : {
      type : Boolean ,
      default : false ,
    } ,
  },
  components: {
      ProcessFieldSelector,
      ProtocolFieldSelector : _=> import( '@common/selects/ProtocolFieldSelector' ) ,
      ProcessTargetSelector,
      Pagination,
      SortSelector,
      BtnLink, Loading,
      customConfirmLayerPopup,
      modifyTagLayerPopup,
  },
  watch: {
    searchLinkData (value) {
      //최초 호출시 두번호출되는 오류
      /*if( this.visible ) this.selectPage(1);*/
    },
    visible(value){
      if( value ){
        this.setTargetProtocolTag(true);
        this.selectPage(1);
      }else{
        this.setTargetProtocolTag(false);
      }
    }
  },
  data () {
    return {
      visible: false,
      processList: [],
      myProcessList: [],
      selected: null,
      pageNo: 1,
      totalPage: 0,
      childMethods:{},
      searchInputData:'',
      selectSearchType : '',
      pageShowCnt: 15,
      selectedProcessIndex: null,
      selectSearchFiled: 0,
      selectSearchTarget: 'name',
      checkMyProcess: false,
      myProcessAllCheck: 0,
      processDeleteAlert: false,
      loading: false,
      processType: 'process',
      sortBy : 'id',
      apis: {},

      isDragging: false,
      offsetX: 0,
      offsetY: 0,
      positionX: 0,
      positionY: 0,
      compareKeyList : ['equipment','measurement','analysis','material'],

      targetProtocolTagList : [],
      connectProtocolTagShowIndex : null,

      tagForClassList : {
                            "material"    : {index : 0, className : "label_01"}
                          , "measurement" : {index : 1, className : "label_02"}
                          , "analysis"    : {index : 1, className : "label_04"}
                          , "equipment"   : {index : 2, className : "label_03"}
                        },
      similarMaterial : true,
      similarPurpose : true,
      similarEquipment : true,
      searchMaterial : '',
      searchPurpose : '',
      searchEquipment : '',

      customConfirmLayerPopupFlag: false,
      modifyTagLayerPopupActive: false,
    }
  },
  async created(){
    //console.log(`this.type = ${this.type}`);
    switch(this.type) {
      case 'process':
        this.processType = 'NORMAL';
        this.targetEditor = this.processEdit;
        this.apis.search = this.$wApi.process.search;
        break;
      case 'protocol':
      case 'onlyProtocol':
      case 'unitProtocol':
        this.processType = this.type === 'onlyProtocol' || this.type === 'unitProtocol' ? 'ONLY_PROTOCOL' : null;
        this.targetEditor = this.protocolEdit;
        this.apis.search = this.$wApi.protocol.search;
        break;
    }
  },
  computed: {
    ...ProcessSelector.mapState({
      selectedProcess: state => state.selectedProcess
    }) ,
    ...ProcessEditor.mapGetters(['getDiagram']),
  },
  beforeDestroy() {
    this.searchInputData = '';
    this.searchMaterial = '';
    this.searchPurpose = '';
    this.searchEquipment = '';
  },
  mounted(){
    this.emitInterface();
    this.selectPage(1);
  },
  filters: {
    timeFilter (time) {
      if(time) time = time.replace('T', ' ');
      else time = '';
      return time
    }
  },
  methods: {
    ...ProcessEditor.mapMutations(['selectNode']),
    ...ProcessSelector.mapMutations(['selelctProcess']),
    ...Dictionary.mapActions(
            [
                    "setRegistDictionaryData",
                    "findRegistDataByCategory",
            ]
    ),

    startDragging(event) {
      this.isDragging = true;
      this.offsetX = event.clientX - event.currentTarget.getBoundingClientRect().left;
      this.offsetY = event.clientY - event.currentTarget.getBoundingClientRect().top;
    },
    dragElement(event) {
      if (this.isDragging) {
        this.positionX = event.clientX - this.offsetX;
        this.positionY = event.clientY - this.offsetY;
      }
    },
    stopDragging() {
      this.isDragging = false;
    },
    preventDrag(event) {
      event.stopPropagation();
    },

    sortSet(value){
      this.sortBy=value;
      this.pageNo=1;
      this.totalPage=0;
      this.search();
    },
    async protocolPreview(){
      if( !this.selected ){
        window.alert('미리보기 할 프로토콜을 선택해주세요.');
        return;
      }
      let targetProtocolInfo = await this.$wApi.protocol.getProtocols({
        processId : this.selected.processId ,
        isMemo : false ,
        isConent : false ,
        isComment  : false ,
      });
      const { href } = this.$router.resolve({
        path : '/protocol/editor',
        query : {
          processId: this.selected.processId,
          editorType: 'protocol',
          protocolId : targetProtocolInfo[0].id,
          keyOfProtocol : targetProtocolInfo[0].keyOfProtocol,
        }
      }) ;
      window.open( href , '_blank' ) ;
    },
    async setProtocol() {
      if (!this.selected) {
        window.alert('연결 할 프로토콜을 선택해주세요.');
        return;
      }
      let connectFlag = 1; //연결
      let message = "해당 프로토콜을 연결하시겠습니까?";
      //공정도 현재 프로토콜의 재료,목적과 연결하기 위해 선택한 프로토콜의 재료,목적이 일치하지않으면 활용으로
      // this.compareKeyList.forEach((item, index) => {
      //   if (this.searchLinkData[item.toUpperCase()]?.text) {
      //     if (this.searchLinkData[item.toUpperCase()]?.text != this.selected[item]) {
      //       connectFlag = 2; // 활용
      //       message = "재료, 목적, 장비 노드중 한개 이상이 달라 연결이 불가능합니다. " +
      //           "<br/>활용<div class=\"tooltip_box\"> <span class=\"tooltip_ico\"></span><div class=\"tooltip_txt\">" +
      //           "<p>기존 프로토콜을 활용하여 새로운 프로토콜을 생성하는 기능입니다.</p></div></div>"
      //           +"하시겠습니까?<br/>"
      //     }
      //   }
      // });

      const checkDictionaryFlag = await this.checkDictionary();
      if(checkDictionaryFlag) {
        const confirmResult = await confirm(message);
        if (confirmResult) {
          try {
            this.loading = true;
            let response = null

            //연결 중복 방지.
            const duplicateCheck = await this.$wApi.protocol.duplicateCheck({
              processId: this.$route.query.processId, // 기존 공정도 ID
              protocolId: this.selected.protocolId, // 연결하고자 하는 원본 only_protocol의 id
              keyOfProtocol: this.searchLinkData.keyOfProtocol, // 공정도 프로토콜 노드의 keyOfProtocol
            });

            if (!duplicateCheck) {
              alert('이미 연결된 프로토콜입니다.')
              return;
            }

            //연결
            response = await this.$wApi.protocol.connect({
              processId: this.$route.query.processId, // 기존 공정도 ID
              protocolId: this.selected.protocolId, // 연결하고자 하는 원본 only_protocol의 id
              keyOfProtocol: this.searchLinkData.keyOfProtocol, // 공정도 프로토콜 노드의 keyOfProtocol
              connectFlag: connectFlag,
            });

            if (response.originProtocolId) {
              await this.status.issueListStatus.reload();
              this.setInnerProtocolId({innerProtocolId: response.protocolId});
              this.$router.push({
                path: '/protocol/editor',
                query: {
                  processId: this.$route.query.processId,
                  editorType: 'protocol',
                  protocolId: response.originProtocolId,
                  keyOfProtocol: response.originKeyOfProtocol,
                }
              });
              //location.reload();
            } else {
              window.alert("프로토콜 저장 중 에러가 발생하였습니다.");
            }

          } catch (e) {
            console.log(e);
          } finally {
            this.loading = false
          }
        }
      }else{
        this.customConfirmLayerPopupFlag = true;
      }

      // let response = await this.$wApi.process.set.protocol({
      //   processId : this.$route.query.processId,
      //   keyOfProtocol : this.searchLinkData.keyOfProtocol,
      //   targetProtocolId : this.selected.protocolId,
      //   protocolConnectFlag : connectFlag
      // }, null);

      // console.log( "response", response )
      // console.log( "protocolPreview" )
    },
    async utilizeProtocol() {
      try {
        this.loading = true;
        let response = null
        //활용
        response = await this.$wApi.protocol.utilize({
          processId: this.$route.query.processId, // 기존 공정도 ID
          innerProtocolId: null,
          innerKeyOfProtocol: this.searchLinkData.keyOfProtocol, // 기존 공정도 keyOfProtocol
          onlyProtocolId: this.selected.protocolId, //활용할 프로토콜 ID
          connectFlag: 2,
          keyOfProtocol: v4(), //활용 시 신규생성될 only_protocol의 keyOfProtocol
          materialTagId: this.searchLinkData["MATERIAL"]?.tagId,
          materialText: this.searchLinkData["MATERIAL"]?.text,
          equipmentTagId: this.searchLinkData["EQUIPMENT"]?.tagId,
          equipmentText: this.searchLinkData["EQUIPMENT"]?.text,
          purposeCategory: this.searchLinkData["MEASUREMENT"] ? "MEASUREMENT" : "ANALYSIS",
          purposeTagId: this.searchLinkData["MEASUREMENT"] ? this.searchLinkData["MEASUREMENT"]?.tagId : this.searchLinkData["ANALYSIS"]?.tagId,
          purposeText: this.searchLinkData["MEASUREMENT"] ? this.searchLinkData["MEASUREMENT"]?.text : this.searchLinkData["ANALYSIS"]?.text,
          isChangeNode: true,
        });
        if (response.originProtocolId) {
          await this.$wApi.dictionary.setDictionaryLinkForNewProtocol({
            processId: response.originProtocolProcessId,
          });
          await this.status.issueListStatus.reload();
          this.setInnerProtocolId({innerProtocolId: response.protocolId});
          this.$router.push({
            path: '/protocol/editor',
            query: {
              processId: this.$route.query.processId,
              editorType: 'protocol',
              protocolId: response.originProtocolId,
              keyOfProtocol: response.originKeyOfProtocol,
            }
          });
          //location.reload();
        } else {
          window.alert("프로토콜 저장 중 에러가 발생하였습니다.");
        }

      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false
      }
    },
    async overwriteProtocol(){
      if( !this.selected ){
        window.alert('불러오기 할 프로토콜을 선택해주세요.');
        return;
      }

      const confirmResult = await confirm("덮어쓰기 시 현재 작성중인 프로토콜은 삭제됩니다. 정말 덮어쓰시겠습니까?")
      if(!confirmResult){
        return;
      }

      this.loading = true;

      //프로토콜 덮어쓰기 (기존 프로토콜 active false 적용(1 => 0) && 프로토콜 신규 추가)
      /*let overwrite_response = await this.$wApi.protocol.overwrite({
        targetProtocolId : this.selected.protocolId, // 복사할 프로토콜
        processId : this.$route.query.processId,  // 공정도id
        keyOfProtocol : this.searchLinkData.keyOfProtocol, // 현재프로토콜의 keyOfProtocol
        protocolId : this.searchLinkData.nowProtocolId, //현재 프로토콜 id
        isOverwrite : true,//덮어쓰기 여부 true 시 덮어쓰기 false 시 활용
      }, null);*/

      //프로토콜 덮어쓰기.
      const overwrite_response = await this.$wApi.protocol.overwrite({
        copyProtocolId : this.selected.protocolId, // 복사할 프로토콜
        overwriteProtocolId: this.$route.query.protocolId, // 덮어쓰기할 프로토콜(기존프로토콜)
      });

      this.loading = false
      if( overwrite_response.protocolId ){
        let path = '';
        path = '/protocol/editor' ;
        this.$router.replace({
          path: path,
          query: {
            processId: this.$route.query.processId,
            editorType: 'protocol',
            protocolId : this.$route.query.protocolId ,
            keyOfProtocol : this.$route.query.keyOfProtocol ,
          }
        }) ;
        // this.$router.go(0);
        location.reload();
      }else{
        window.alert("프로토콜 저장 중 에러가 발생하였습니다.");
        this.visible =false;
      }
      // console.log( "response", response )
      // console.log( "protocolPreview" )
    },
    setUnitProtocol(){
      if( !this.selected ){
        window.alert('붙여넣기 할 유닛프로토콜을 선택해주세요.');
        return;
      }
      this.$emit('select-protocol', this.selected);
    },
    getChildMethods(methods) {
      this.childMethods = methods;
    },
    emitInterface() {
      this.$emit('setMethod', {show : this.show, hide: this.hide});
    },
    selectProcess(index, event){
      this.selectedProcessIndex = index;
      this.selected = this.processList[index];
      this.$emit('select-process', this.selected);
    },
    async selectPage(index) {
      this.pageNo = index;
      this.selectedProcessIndex = null;
      this.selected = null;
      await this.search();
      return
    },
    hide() {
      this.selectedProcessIndex = null;
      this.selected = null;
      this.visible = false;
      this.searchInputData = '';
      this.searchMaterial = '';
      this.searchPurpose = '';
      this.searchEquipment = '';
      this.similarMaterial = true;
      this.similarPurpose = true;
      this.similarEquipment = true;
    },
    show() {
      this.visible = true;
      // this.selectPage(1);
    },

    async search() {
      if( !this.visible ) return;
      if( this.type === 'onlyProtocol' && this.searchLinkData.keyOfProtocol == undefined ) return;

      this.loading = true
      try{
        const searchType = this.searchType();
        if(!this.apis.search) this.wApiSetter();
        let response = await this.apis.search(searchType);
        const processList = []

        /** 로그 등록 */
        await this.$wApi.trace.log({
          type : this.type === 'process' ? 'PD' : 'PR', //PD 공정도, PR 프로토콜
          code : 'S', //N 생성 M 수정 S 검색 R 조회
          subCode : '01',
          keyword : this.searchInputData,
          result : response.content.length ?? 0 ,
          ptlId : 0
        });
        /** 로그 등록 */

        for(let item of response.content) {
          if(this.type==='onlyProtocol' && !this.$props.overWriteProtocolMode) {
            const connectedFlag = this.setConnectFlag(item);
            item["connectedFlag"] = connectedFlag;
          }
          processList.push(item)
        }

        this.processList = processList;
        this.totalPage = response.totalPages;
        // this.pageNo = 0;
        this.loading = false
      } catch(error){
        // console.log( "error", error)
        this.loading = false
      }
    },
    setConnectFlag(data) {
      let flag = true;
      for(let index=0; index<this.compareKeyList.length; index++){
          let upperKey = this.compareKeyList[index].toUpperCase();
          let lowerKey = this.compareKeyList[index].toLowerCase();
          if(this.searchLinkData[upperKey]?.text || this.searchLinkData[lowerKey]?.text){
              if(this.searchLinkData[upperKey]?.text != data[lowerKey]){
                  flag = false;
              }
          }
      }
      return flag;
    },
    inputEnter(event) {
      if(event.code === 'Enter' || event.keyCode === 13) {
        this.pageNo=1;
        this.totalPage=0;
        this.search();
      }
    },
    async processPreview(){
      this.$emit('process-preview', this.selected);
    },
    async processEdit() {

      if( this.selected.editerMode === true ){
        let path = '/process/editor';
        this.$router.push({
          path: path,
          query: {
            processId: this.selected.processId,
            editorType: 'process',
            protocolId: null
          }
        }) ;

        this.$router.go(0);

        this.hide();
        this.initHandler() ;
        let { user , $route : { query }} = this ;
        this.setInitInfo({ user , query }) ;
        await this.setProcess_N_UserInfo() ;
        // this.initItems() ; 
        await this.initElements() ;
      }else{
        window.alert( "해당 공정도의 편집권한이 없습니다." );
      }
    },
    async processDelete() {
      // 테스트를 위해 현재는 delete 사용
      // 추후 삭제가 아닌 active , deactive 형태로 API가 변결 될 예정
      let status = false;
      this.loading = true
      for (const item of this.myProcessList) {
        if(item.checked) {
          await this.$wApi.process.delete(null, item.processId);
          await this.$wApi.protocol.active(null, {
            processId: item.processId,
            active: 0
          });
          status = true

        }
      }
      this.loading = false
      if(status === true) this.search()
      this.processDeleteAlert = false
    },
    processCheck (event) {
      // myProcessAllCheck
      const index = event.currentTarget.dataset.index
      const item = this.processList[index]
      if(event.currentTarget.checked === true) {
        this.myProcessAllCheck++
      } else {
        this.myProcessAllCheck--
      }
      item.checked = event.currentTarget.checked
      this.myProcessAllCheck = Math.max(0, this.myProcessAllCheck)
      this.myProcessAllCheck = Math.min(this.myProcessList.length, this.myProcessAllCheck)

      // console.log('Process check : ', this.myProcessAllCheck, this.myProcessList.length)
    },
    async protocolEdit() {
      window.location.href = `/protocol/editor?editorType=protocol&processId=${this.selected.processId}&protocolId=${this.selected.protocolId}&keyOfProtocol=${this.selected.keyOfProtocol}`;
      this.hide();
    },
    allCheck(e) {
      if(e.currentTarget.checked === false) {
        this.myProcessAllCheck = 0;
      } else {
        this.myProcessAllCheck = this.myProcessList.length;
      }
      for(const item of this.myProcessList) {
        item.checked = e.currentTarget.checked;
      }
    },
    targetEditor(){
      // editor type 용
    },
    wApiSetter() {
      switch (this.type) {
        case 'process':
          this.processType = 'NORMAL';
          this.targetEditor = this.processEdit;
          this.apis.search = this.$wApi.process.search;
          break;
        case 'protocol':
        case 'onlyProtocol':
        case 'unitProtocol':
          this.processType = this.type === 'onlyProtocol' || this.type === 'unitProtocol' ? 'ONLY_PROTOCOL' : null;
          this.targetEditor = this.protocolEdit;
          this.apis.search = this.$wApi.protocol.search;
          break;
      }
    },
    searchType() {
      let searchProperty = {
        query: this.searchInputData,
        targetField: this.selectSearchTarget,
        // protocolType: this.selectSearchFiled,
        pageNo: this.pageNo,
        perPage: this.pageShowCnt,
        searchMaterial:this.searchMaterial? this.searchMaterial.trim() : "",
        searchPurpose:this.searchPurpose? this.searchPurpose.trim() : "",
        searchEquipment:this.searchEquipment? this.searchEquipment.trim() : "",
        similarMaterial: this.similarMaterial,
        similarPurpose: this.similarPurpose,
        similarEquipment: this.similarEquipment,
      }
      for( let nodeType in  this.searchLinkData ){
        if( nodeType === 'keyOfProtocol' ) continue;
        searchProperty[nodeType.toLowerCase()] = this.searchLinkData[nodeType]?.text;
      }

      searchProperty.fieldId = this.selectSearchFiled === 0 ? null : this.selectSearchFiled;

      if(this.type == 'process') {
        searchProperty.processType = 'NORMAL';
        searchProperty.isThumbnail = 0;
        searchProperty.isProtocol = 0;
        searchProperty.isMyData = this.checkMyProcess ? 1 : 0;
      }else{
        searchProperty.isMyData = this.checkMyProcess ? 1 : 0;
        searchProperty.protocolType = this.selectSearchType;
      }

      if( this.type == 'onlyProtocol' ){
        searchProperty.protocolType = 'FULL';
      }

      if( this.type == 'unitProtocol' ){
        searchProperty.protocolType = 'UNIT';
        searchProperty.sortBy = this.sortBy;
      }
      // console.log("searchProperty", searchProperty )
      return searchProperty;
    },
    setSearchInputData(e) {
      if (!(e.code === 'Enter' || e.keyCode === 13)) {
        this.searchInputData = e.target.value;
      }
    },
    setSearchMaterial(e) {
      if (!(e.code === 'Enter' || e.keyCode === 13)) {
        this.searchMaterial = e.target.value;
      }
    },
    setSearchPurpose(e) {
      if (!(e.code === 'Enter' || e.keyCode === 13)) {
        this.searchPurpose = e.target.value;
      }
    },
    setSearchEquipment(e) {
      if (!(e.code === 'Enter' || e.keyCode === 13)) {
        this.searchEquipment = e.target.value;
      }
    },
    async setTargetProtocolTag(setFlag, resetFlag){
      let tempList = [];
      if (this.type === 'onlyProtocol' && !this.overWriteProtocolMode && setFlag === true) { // setting (protocol 연결 팝업일 경우에만 동작시킴)
        let useData = this.searchLinkData;
        if(resetFlag === true){
          useData = {};
          const nodeDataArray = this.getDiagram.model.nodeDataArray;
          const linkDataArray = this.getDiagram.model.linkDataArray;
          let protocolInfo = checkProtocolLink(linkDataArray, nodeDataArray, this.searchLinkData.keyOfProtocol);
          for (let node of protocolInfo.nodes.filter(o => o.category !== 'PROTOCOL')) {
            if (node.category === 'EQUIPMENT') {
              useData.keyOfProtocol = node.key;
            }
            if(!useData[node.category]){
              useData[node.category] = {text :node.text, tagId : node.tagId};
            }
          }
        }
        this.compareKeyList.forEach(key => {
          let className = "";
          let index = 0;
          switch(key){
            case "material":
              className = "label_01";
              index = 0;
              break;
            case "measurement":
              className = "label_02";
              index = 1;
              break;
            case "analysis":
              className = "label_04";
              index = 1;
              break;
            case "equipment":
              className = "label_03";
              index = 2;
              break;
          }
          if(useData[key.toUpperCase()]) { // 데이터가 존재할때만
            let targetProtocolTag = {};
            targetProtocolTag = useData[key.toUpperCase()];
            targetProtocolTag["index"] = index;
            targetProtocolTag["class"] = className;
            tempList.push(targetProtocolTag);
          }
        });

        this.targetProtocolTagList = [];
        this.targetProtocolTagList = tempList.sort(function(a, b)  {
                                                    if(a.index > b.index) return 1;
                                                    if(a.index === b.index) return 0;
                                                    if(a.index < b.index) return -1;
                                                  });

      } else { // 초기화
        this.targetProtocolTagList = [];
      }
    },
    setShowProtocolTag(dataIndex){
      this.connectProtocolTagShowIndex = dataIndex;
    },
    clear(e){
      this[e.target.className] = "";
    },
    async checkDictionary() {

      let dataObj = {};
      dataObj.targetProcessId = this.selected.processId;
      dataObj.targetkey = this.selected.keyOfProtocol;
      dataObj.correctionTargetProcessId = this.$route.query.processId;
      dataObj.correctionTargetKey = this.searchLinkData.keyOfProtocol;
      await this.setRegistDictionaryData(dataObj);

      let material = await this.findRegistDataByCategory({category:"MATERIAL"});
      let analysis = await this.findRegistDataByCategory({category:"ANALYSIS"});
      let measurement = await this.findRegistDataByCategory({category:"MEASUREMENT"});
      let equipment = await this.findRegistDataByCategory({category:"EQUIPMENT"});

      if(measurement.registTypeError || analysis.registTypeError){
        return false;
      }

      let api = this.$wApi;
      let selectedData = this.selected;
      let queryProcessId = this.$route.query.processId;

      async function callDictionaryApi(data) {
        let correctionTargetDictionary = await api.dictionary.getDictionaryByKey({
          processId: queryProcessId,
          key: data.correctionTargetProcessNode.key,
          tagId: data.correctionTargetProcessNode.tagId,
        });
        let targetDictionary = await api.dictionary.getDictionaryByKey({
          processId: selectedData.processId,
          key: data.targetProcessNode.key,
          tagId: data.targetProcessNode.tagId,
        });
        if (correctionTargetDictionary.id && targetDictionary.id) {
          if (correctionTargetDictionary.id == targetDictionary.id) {
            return true;
          } else {
            // 양쪽 확인.
            if (targetDictionary.similarTagList.filter(inData => inData.tagId == data.correctionTargetProcessNode.tagId).length == 0
                    && correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == data.targetProcessNode.tagId).length == 0) {
              for (const targetTag of targetDictionary.similarTagList) {
                for (const correctionTag of correctionTargetDictionary.similarTagList) {
                  if (targetTag.tagId == correctionTag.tagId) {
                    return true;
                  }
                }
              }
              return false;
            } else {
              return true;
            }
          }
        } else if (!correctionTargetDictionary.id && targetDictionary.id) { // 둘 중 한개만 있을때
          if (targetDictionary.similarTagList.filter(inData => inData.tagId == data.correctionTargetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
            return false;
          } else {
            return true;
          }
        } else if (correctionTargetDictionary.id && !targetDictionary.id) { // 둘 중 한개만 있을때
          if (correctionTargetDictionary.similarTagList.filter(inData => inData.tagId == data.targetProcessNode.tagId).length == 0) { // tagId가 포함되어 있는지 확인.
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }

      if(material.correctionTargetProcessNode.tagId != material.targetProcessNode.tagId){
        const checkDictionary = await callDictionaryApi(material);
        if(!checkDictionary){
          return false;
        }
      }
      if(analysis.registFlag){
        if(analysis.correctionTargetProcessNode.tagId != analysis.targetProcessNode.tagId){
          const checkDictionary = await callDictionaryApi(analysis);
          if(!checkDictionary){
            return false;
          }
        }
      }else if (measurement.registFlag){
        if(measurement.correctionTargetProcessNode.tagId != measurement.targetProcessNode.tagId){
          const checkDictionary = await callDictionaryApi(measurement);
          if(!checkDictionary){
            return false;
          }
        }
      }
      if(equipment.correctionTargetProcessNode.tagId != equipment.targetProcessNode.tagId){
        const checkDictionary = await callDictionaryApi(equipment);
        if(!checkDictionary){
          return false;
        }
      }

      return true;
    },
    openModifyTagLayerPopup(){
      this.customConfirmLayerPopupFlag = false;
      this.modifyTagLayerPopupActive = true;
    },
  }
  }
  </script>

<style lang="scss">
  .showPopup-enter-active {
    visibility: hidden;
    backdrop-filter: blur( 0px );
    transition: visibility 0.475s , backdrop-filter 0.475s;

    .process-h-wrap {
      opacity: 0;
      transform: scale(0);
      transition-property: transform , opacity;
      transition-duration: 0.475s , 0.475s;
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
    }
  }
  .showPopup-leave-active {
    transition: visibility 0.475s , backdrop-filter 0.475s;
    .process-search-wrap {
      transition-property: transform , opacity;
      transition-duration: 0.475s , 0.475s;
      transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);
    }
  }
  .showPopup-enter-to {
    visibility: visible;
    // backdrop-filter: blur( 2px );

    .process-search-wrap {
      opacity: 1;
      transform: scale(1);
    }
  }
  .showPopup-leave-to {
    visibility: hidden;

    .process-search-wrap {
      opacity: 0;
      transform: scale(0);
    }
  }

  .process-search-popup {
    display: flex; width: 100%; height: 100%;
    align-items: center; justify-content: center;
    position: fixed; top:0; left:0; right:0; bottom: 0;
    z-index: var(--popup-index-max);
    // backdrop-filter: blur( 2px );
  }
  .process-search-wrap {
    $padding: 24px;
    display: grid;
    grid-template:
      'title' auto
      'tag' auto
      'search' auto
      'result' 1fr
      'pagination' auto
      'buttons' auto /
      1fr
    ;
    position: relative;
    max-width: 1110px;
    width:1110px;
    max-height: 90%;
    padding: $padding;
    background-color: #fff;
    border: 1px solid $gray-9;
    box-shadow: 0px 4px 16px rgba(91, 91, 91, 0.3);

    h2 {
      grid-area: title;
      margin: 0 0 24px 0;
      font-size: 20px;
      @include text-prt-sb;
    }
    .search-close {
      $size: 30px;
      $centerPos: $padding - (($size - 14) /2);
      position: absolute; top: $centerPos; right: $centerPos;
      width: $size; height: $size;
      background: url('../../assets/icons/icon-close.svg') center no-repeat;
      font-size: 0;
      cursor: pointer;
    }
    .protocol_label_list {
      display: flex; align-items: center;
      grid-area: tag;
      z-index: 2;
      margin: 0px 20px 20px 0px;
      & > span {
        display: inline-block;
        @include text-prt-sb;
        margin: 0px 20px 0px 0px;
      }
    }
    .search-option {
      grid-area: search;
      display: flex; align-items: center;
      gap: 8px;
      & > span {
        display: inline-block;
        @include text-prt-sb;
        margin: 0 0px 0 16px;
      }
      z-index: 2;
    }
    .data-select {
      min-width: 120px; height: 32px;
      border: 1px solid #999;
      border-radius: 4px;
      color: #666;

      datalist {
        border-radius: 4px;
      }
    }
    input[type='checkbox'] {
      width: 18px; height: 18px;
      border: 2px solid #999;
      margin-right: 10px;
      appearance: none;
      background-size: 18px;

      &:checked {
        background: url('../../assets/icons/icon-check-circle.svg') center no-repeat #fff;
        border-color: #333;
        border-width: 3px;
      }
    }
    .search-input {
      display: inline-flex; align-items: center;
      width: 300px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #999;
      input {
        flex-shrink: 2;
        width: 100%;
        border: 0;
        padding: 0 10px;
      }
      button {
        flex-shrink: 0;
        width: 40px; height: 100%;
        font-size: 0;
        background: url('../../assets/icons/magnify.svg') right 10px center no-repeat;
      }
    }
    .myProcess {
      display: flex; align-items: center;
      margin-left: 16px;
      cursor: pointer;
      @include text-prt-sb;

    }
    .search-table {
      grid-area: result;
      position: relative;
      margin: 32px 0 0;
      overflow: auto;
      @include scrlbar;
      >font {
        font-size: 14px;
      }
    }
    .search-result {
      border-collapse: separate;
      thead {
        position: sticky; top:0;
        background-color: #fff;
        th {
          height: 35px;
          border-bottom: 1px solid #333;
          text-align: center; vertical-align: middle;
          font-size: 14px;
          @include text-prt-sb;
          &:nth-child(1) {width: 5px;}
          &:nth-child(2) {width: 200px;}
          &:nth-child(3) {width: 220px;}
          &:nth-child(4) {width: 585px;}
          &:nth-child(5) {width: 100px;}
        }
      }
      tbody {
        tr {
          cursor: pointer;
          &:hover, &.on { background-color: #E8F6F7;}
        }
        td {
          min-height: 40px;
          padding: 8px 5px;
          border-bottom: 1px solid #ddd;
          vertical-align: middle;
          text-align: center;
          font-size: 14px; color: #333;
          @include text-prt-sb;
          line-height: 1.4em;
          &:nth-child(4) {text-align: left;}
          &:nth-child(3) {text-align: left;}

          span {
            display: inline-block;
            &:first-child {
              color: #999;
            }
          }
          input {
            vertical-align: middle;
          }
        }
      }

    }
    &.deactive {
      &:after {
        content:'';
        display: block;
        position: absolute; top:0; left:0; right:0; bottom:0;
        background-color: rgba(0,0,0, .5);
        z-index: 2;
      }
    }
  }
  .pagination {
    grid-area: pagination;
    margin: 24px 0;
  }
  .button-wrap {
    grid-area: buttons;
    display: flex; align-items: center; justify-content: center;
    gap: 8px;
  }
  .processRemove {
    min-width: 62px;
    padding: 8px;
    margin-left: auto;
    border: 1px solid #ddd;
    border-radius: 3px;
    background-color:#eee;
    font-size: 12px;
  }
  .alertPopup {
    .title {
      margin-bottom: 6px;
    }
    .content {
      font-size: 12px;
      line-height: 24px;
      color: #999;
    }
    .buttons-wrap {
      display: flex; justify-content: center; gap: 8px;
      margin-top: 14px;
    }
  }

  @keyframes contentShow {
    0% { transform: translate(0, -20%) }
    100% { transform: translate(0, 0) }
  }

  .search-input-tag {
      display: inline-flex; align-items: center;
      width: 200px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #999;
      input {
        flex-shrink: 2;
        width: 100%;
        border: 0;
        padding: 0 10px;
      }
      button {
        flex-shrink: 0;
        width: 40px; height: 100%;
        font-size: 0;
        background: url('../../assets/icons/magnify.svg') right 10px center no-repeat;
      }
    }
  </style>